module.exports = __webpack_public_path__ + "static/media/after_service.05f1227a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/after_service.pdf
// module id = 294
// module chunks = 2